import { render, staticRenderFns } from "./exApplyForModificationFrom.vue?vue&type=template&id=1117251c&scoped=true&"
import script from "./exApplyForModificationFrom.vue?vue&type=script&lang=js&"
export * from "./exApplyForModificationFrom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1117251c",
  null
  
)

export default component.exports